import TransactionsCommunities from "./TransactionsCommunities";

export default TransactionsCommunities;
